import { createAction, props } from '@ngrx/store';

export const track = createAction('[Tracking] Track - Send parts of state to Tracking api',
    props<{
        event?: any
    }>());

export const replaceState = createAction('[Tracking] Replace State',
    props<{
        url: string
    }>());

export const setCampaign = createAction('[Tracking] Set Campaign',
    props<{
        queryParams: any
    }>());

export const setPixel = createAction('[Tracking] Set Pixel',
    props<{
        trackingObject: any
    }>());

export const clearPixel = createAction('[Tracking] Clear Pixel');
